import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchGetDynamicPhone } from '../../repositories/public/newbuilding-dynamic-calltracking/v1/get-dynamic-phone';
export var fetchNewbuildingDynamicCalltracking = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(httpApi, parameters) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetchGetDynamicPhone({
            httpApi: httpApi,
            config: {
              requestConfig: {
                headers: [['Content-Type', 'application/json']]
              }
            },
            parameters: parameters
          });
        case 2:
          response = _context.sent;
          return _context.abrupt("return", response.response);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchNewbuildingDynamicCalltracking(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();